import axios from 'axios';
import { ApiBaseUser, ApiDriversResponse, ApiDriverUser, ApiUserSummary, UserAvailabilityResponse } from '@/rennovation/planning-view/types/api/users-response';

export class UserApiService {
	private baseUrl = '/api/users';

	async getUsers(): Promise<ApiDriverUser[]> {
		const response = await axios.get<ApiDriversResponse>(this.baseUrl);
		return response.data;
	}

	async create(userData: Partial<ApiBaseUser>): Promise<ApiBaseUser> {
		const response = await axios.post(this.baseUrl, userData);
		return response.data;
	}

	async update(id: string, userData: Partial<ApiBaseUser>): Promise<ApiBaseUser> {
		const response = await axios.put(`${this.baseUrl}/${id}`, userData);
		return response.data;
	}

	async delete(id: string): Promise<void> {
		await axios.delete(`${this.baseUrl}/${id}`);
	}

	async listDrivers() {
		const drivers = await axios.get(`/api/users/drivers`);
		return drivers;
	}

	async loadUnallocatedUsers(days: string[]): Promise<string[]> {
		const response = await axios.post(`${this.baseUrl}/unallocated`, { days: days });
		return response.data;
	}

	async loadAvailableDriversByDay(day: string): Promise<UserAvailabilityResponse> {
		const response = await axios.get(`${this.baseUrl}/allocation-by-date?date=${day}`);
		return response.data;
	}
}
